import {Injectable} from "@angular/core";
import {Circle} from "./figures/Circle";
import {CesiumAdapterService} from "../services/cesiumAdapter21/cesium-adapter.service";
import {Point} from "./figures/Point";
import {Polyline} from "./figures/Polyline";
import {Polygon} from "./figures/Polygon";
import {Rectangle} from "./figures/Rectangle";
import {ThreeDModel} from "./figures/ThreeDModel";
import {DynamicBillboardEntity} from "./figures/DynamicBillboardEntity";
import {DynamicBillboardPrimitive} from "./figures/DynamicBillboardPrimitive";
import {ObjectConfig} from "../models/ObjectConfig";
import {FigureMainClass} from "./figures/figureMainClass";
import {ToolsService} from "@src/app/services/toolsService/tools.service";

@Injectable({
  providedIn: 'root'
})

export class ItemMapObjectFactory {

  constructor(private view: CesiumAdapterService, private toolService: ToolsService) {}

  public create(object : ObjectConfig) : FigureMainClass {
    switch (object.getToolType()) {
      case ObjectConfig.TYPE_POINT:
        return new Point(object, this.view, this.toolService);

      case ObjectConfig.TYPE_POLYLINE:
        return new Polyline(object, this.view, this.toolService);

      case ObjectConfig.TYPE_POLYGON:
        return new Polygon(object, this.view, this.toolService);

      case ObjectConfig.TYPE_FIXED_FIGURE:
        if (window['BILLBOARD_DYNAMIC_FIGURES_ALLOWED']) {
          const tool = object.getTool();
          if (typeof tool.url_for_dynamic_icon !== 'undefined' && tool.url_for_dynamic_icon
            || typeof tool.dynamic_image_code !== 'undefined' && tool.dynamic_image_code
          ) {
            //return new DynamicBillboardEntity(object, this.view, this.toolService);
            return new DynamicBillboardPrimitive(object, this.view, this.toolService);
          }
        }
        return new ThreeDModel(object, this.view, this.toolService);

      case ObjectConfig.TYPE_CIRCLE:
        return new Circle(object, this.view, this.toolService);

      default:
        throw new Error("Unknown item map object type: " + object.getToolType());
    }
  }

  // public createFromSimpleItemData(object){
  //   console.log('createFromSimpleItemData', object.tool_type);
  //   if (object.tool_type == 'point'){
  //       return new Point(this.view, object)
  //   }
  //   else if (object.tool_type == 'polyline'){
  //     return new Polyline(this.view, object);
  //   }
  //   else if (object.tool_type == 'polygon'){
  //     return new Polygon(this.view, object)
  //   }
  //   else if (object.tool_type == 'rectangle'){
  //     return new Rectangle(this.view, object)
  //   }
  //   else if (object.tool_type == 'circle'){
  //     return new Circle(this.view, object);
  //   }
  //   else if (object.tool_type == 'model' || object.tool_type == 'fixed-figure'){
  //     return new ThreeDModel(this.view, object)
  //   }
  // }
}
